import { render, staticRenderFns } from "./npc-character.vue?vue&type=template&id=2c36fed2&scoped=true&"
import script from "./npc-character.vue?vue&type=script&lang=js&"
export * from "./npc-character.vue?vue&type=script&lang=js&"
import style0 from "./npc-character.vue?vue&type=style&index=0&id=2c36fed2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36fed2",
  null
  
)

export default component.exports